import { useEffect, useRef } from "react";

import { Link } from "react-router-dom";
import { usePageTitle } from "../hook/usePageTitle";

const GamesPage = () => {
    usePageTitle("Play Jackpot Slots");

    const gameFrameRef = useRef(null);
    const gameLoadingRef = useRef(null);

    useEffect(() => {
        const iframe = gameFrameRef.current;
        const loadingScreen = gameLoadingRef.current;

        const handleLoad = () => {
            if (loadingScreen) {
                loadingScreen.style.display = 'none';
            }
        };

        if (iframe) {
            iframe.addEventListener('load', handleLoad);
        }

        return () => {
            if (iframe) {
                iframe.removeEventListener('load', handleLoad);
            }
        };
    }, []); 

    return (
        <div className="game-page">
            <div className="game-header">
                <Link to="/" className="logo">
                    <svg className="logo-icon" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"
                        style={{ width: "32px", height: "32px" }}>
                        <defs>
                            <linearGradient id="logoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" style={{ stopColor: "#ffff1c" }} />
                                <stop offset="100%" style={{ stopColor: "#00c3ff" }} />
                            </linearGradient>
                        </defs>
                        <circle cx="50" cy="50" r="45" fill="none" stroke="url(#logoGrad)" strokeWidth="6" />
                        <path d="M35 30 L65 50 L35 70 Z" fill="url(#logoGrad)" />
                        <circle cx="50" cy="50" r="20" fill="none" stroke="url(#logoGrad)" strokeWidth="3"
                            strokeDasharray="10 5" />
                    </svg>
                    <span className="logo-text" style={{ fontSize: "18px" }}>Socialine</span>
                </Link>
                <div className="game-header-right">
                    <span className="game-disclaimer">For entertainment only. No real money involved.</span>
                    <Link to="/" className="btn btn-secondary" style={{ padding: "8px 16px", fontSize: "12px" }}>Back to Home</Link>
                </div>
            </div>

            <div className="game-frame-container">
                <div className="game-loading" ref={gameLoadingRef}>
                    <div className="spinner"></div>
                    <p>Loading game...</p>
                </div>
                <iframe 
                    src="https://socialine.site/game" 
                    className="game-iframe" 
                    ref={gameFrameRef} 
                    name="gameframe"
                    allowFullScreen 
                ></iframe>
            </div>
        </div>
    );
};

export default GamesPage;